import { render, staticRenderFns } from "./SettingStaff.vue?vue&type=template&id=362de940&"
import script from "./SettingStaff.vue?vue&type=script&lang=js&"
export * from "./SettingStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports